import { Fragment, h } from '@atomify/jsx';

interface RadioProps {
    validationTypes?: string | null;
    validationRegex?: string | null;
    validationErrorMessage?: string | null;
    requiredErrorMessage?: string | null;
    value?: any;
    horizontal?: boolean;
    classes?: string;
    label?: string | Text | null;
    error?: string;
    disabled?: boolean;
    displayName?: string | null;
    required?: boolean;
    hook?: string;
    options: Array<{
        disabled?: boolean;
        name: string;
        id: string;
        checked?: boolean;
        hook?: string;
        attr?: string[];
        label: string | Text;
        value: string;
    }>;
}

export const RadioElement = ({
    validationTypes,
    validationRegex,
    validationErrorMessage,
    requiredErrorMessage,
    value,
    horizontal,
    disabled,
    classes,
    options,
    label,
    displayName,
    required,
    hook,
    error,
}: RadioProps) => {
    const inputClasses = {
        ['c-radio']: true,
        ['form__item']: true,
        'radio--horizontal': horizontal,
        ['form__item--disabled']: disabled,
    };

    if (options.length === 0) return null;

    return (
        <bpd-radio
            validation-types={validationTypes}
            validation-regex={validationRegex}
            validation-error-message={validationErrorMessage}
            required-error-message={requiredErrorMessage}
            bindValue={value}
            class={classes}
            displayName={displayName}
            {...{
                [`js-hook-${hook}`]: !!hook,
            }}>
            <div class={inputClasses}>
                {label && <p class="u-body-normal-bold u-margin-bottom-1">{label}</p>}
                <div class="radio__wrapper">
                    {options &&
                        options.map((item) => (
                            <Fragment>
                                <input
                                    class="radio__input u-sr-only"
                                    type="radio"
                                    name={item.name}
                                    id={item.id}
                                    required={required}
                                    disabled={disabled}
                                    checked={item.checked}
                                    value={item.value}
                                    {...{
                                        [`js-hook-${item.hook ? item.hook : ''}`]: !!item.hook,
                                        ...item.attr,
                                    }}
                                />

                                <label class="radio__label" for={item.id}>
                                    <span class="radio__hover-helper"></span>
                                    {item.label}
                                    <span class="radio__focus-helper"></span>
                                </label>
                            </Fragment>
                        ))}
                </div>
                <div class="form__item-error" role="alert">
                    {error}
                </div>
            </div>
        </bpd-radio>
    );
};
